import { render } from "./v-checkbox.vue?vue&type=template&id=5dee6b43"
import script from "./v-checkbox.vue?vue&type=script&lang=js"
export * from "./v-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__